export const clamp = (n: number, min: number, max: number) => Math.min(max, Math.max(min, n));

export const round2 = (n: number) => Math.round((Number(n || 0) + Number.EPSILON) * 100) / 100;

export const num = (v: any) => {
  const n = Number(String(v ?? '').replace(/,/g, '').trim());
  return Number.isFinite(n) ? n : 0;
};


// import { D, toNum, MONEY_SCALE, } from '../math/decimalMoney';

// export const clamp = (n: number, min: number, max: number) => Math.min(max, Math.max(min, n));

// export const round2 = (v: any) => {
//   const s = String(v ?? '').replace(/,/g, '').trim();
//   return toNum(D(s === '' ? 0 : s), MONEY_SCALE);
// };

// export const num = (v: any) => {
//   const n = Number(String(v ?? '').replace(/,/g, '').trim());
//   return Number.isFinite(n) ? n : 0;
// };
